/**
 * @since 2.0.0
 */
/** @internal */
export const isNonEmptyArray = self => self.length > 0;
//# sourceMappingURL=array.js.map